import { useSelector } from "react-redux";

import { userSelector } from "store/auth/selectors";

import { UserRole } from "constants/enums";

export const useAdmin = () => {
  const user = useSelector(userSelector);

  return user?.role === UserRole.ROOT_CREATOR;
};